import { Notification } from 'element-ui'

const YNotification = Notification

export default YNotification
